export type BankLike = {
  bankCode?: string | number;
  code?: string | number;
  bankName?: string;
  name?: string;
};

export function bankCodeCandidates(code: unknown): string[] {
  if (code === null || code === undefined) return [];
  const raw = String(code).trim();
  if (!raw) return [];
  const numNorm = /^\d+$/.test(raw) ? String(Number(raw)) : raw;
  const out = [raw, numNorm, raw.padStart(3, "0"), numNorm.padStart(3, "0")];
  return Array.from(new Set(out));
}

export function resolveBankNameFromLookup(
  lookup: Map<string, string>,
  bankCode: unknown
): string {
  const codes = bankCodeCandidates(bankCode);
  for (const c of codes) {
    const name = lookup.get(c);
    if (name) return name;
  }
  return "—";
}

export function resolveBankNameFromLists(
  bankCode: unknown,
  palmpayBanks: BankLike[] = [],
  legacyBanks: BankLike[] = []
): string {
  const codes = bankCodeCandidates(bankCode);
  if (codes.length === 0) return "—";

  const palmpayMatch = palmpayBanks.find((b) =>
    bankCodeCandidates(b?.bankCode).some((c) => codes.includes(c))
  );
  if (palmpayMatch) {
    return (palmpayMatch.bankName || palmpayMatch.name || "—").trim() || "—";
  }

  const legacyMatch = legacyBanks.find((b) =>
    bankCodeCandidates(b?.code).some((c) => codes.includes(c))
  );
  return (legacyMatch?.bankName || legacyMatch?.name || "—").trim() || "—";
}
